export var PercentUnitId;
(function (PercentUnitId) {
    PercentUnitId["Percent1"] = "percent(1)";
    PercentUnitId["Percent100"] = "percent(100)";
})(PercentUnitId || (PercentUnitId = {}));
export var percentFormatUnitIds = [
    PercentUnitId.Percent1,
    PercentUnitId.Percent100,
];
//# sourceMappingURL=percent.js.map